import { Component, inject } from '@angular/core';
import { LocaleService, TranslatePipe } from '@cmi/addin-core';

@Component({
  selector: 'cmi-language-settings',
  imports: [TranslatePipe],
  templateUrl: './lang.html'
})
export class LanguageSettings {
  private readonly _localeService = inject(LocaleService);

  public readonly currentLocale = this._localeService.currentLocale;

  public selectLanguage(locale: 'de' | 'fr'): void {
    void this._localeService.switchLanguage(locale);
  }
}
